import {
  RatableItemType,
  type RatablePairingItem,
  type RatableProductItem,
} from '../useRatableItems';
import { useFilteredFoodFeedbackItems } from './useFilteredFoodFeedbackItems';

export type UseFoodFeedbackItemsProps = {
  item: RatablePairingItem | RatableProductItem;
  rating: boolean | null;
};

export function useFoodFeedbackItems(props: UseFoodFeedbackItemsProps) {
  const { item, rating } = props;

  const { likedPairings, dislikedPairings, likedProducts, dislikedProducts } =
    useFilteredFoodFeedbackItems();

  if (item.type === RatableItemType.Pairing && rating === true) {
    return likedPairings;
  } else if (item.type === RatableItemType.Pairing && rating === false) {
    return dislikedPairings;
  } else if (item.type === RatableItemType.Product && rating === true) {
    return likedProducts;
  } else if (item.type === RatableItemType.Product && rating === false) {
    return dislikedProducts;
  } else {
    return [];
  }
}
